
import { defineComponent } from "vue";

export default defineComponent({
  name: "SendButton",
  props: {
    title: {
      type: String,
      required: true
    }
  }
});
